import { wsHubRegister, wsHubOnDataChangedEvent, wsHubUnregister, wsHubIsGroupRegistered } from './hubConnector';

export default {
    install: (Vue) => {
        Vue.prototype.$wsHubRegister = wsHubRegister;
        Vue.prototype.$wsHubOnDataChangedEvent = wsHubOnDataChangedEvent;
        Vue.prototype.$wsHubUnRegister = wsHubUnregister;
        Vue.prototype.$wsHubIsGroupRegistered = wsHubIsGroupRegistered;
    }
}